import * as React from 'react';
import images from 'react-payment-inputs/images';

import { RectangleButton } from '../buttons'
import { Styled } from './styled'

export const PaymentMethodCardInput = (props) => {
  const {
    getCardNumberProps,
    getExpiryDateProps,
    getCVCProps,
    getCardImageProps,
    onCardNumberChange,
    onExpiryChange,
    onCvcChange,
    onSubmit,
    isValid
  } = props;
  return (
    <>
      <Styled.CardInputRow isCardInput={true}>
      <Styled.CardNumberInput isCardInput={true} {...getCardNumberProps({ onChange: onCardNumberChange })} />
      </Styled.CardInputRow>
      <Styled.CardInputRow isCardInput={true}>
        <Styled.CardExpiryCvcInput isCardInput={true} {...getExpiryDateProps({ onChange: onExpiryChange })} />
        <Styled.CardExpiryCvcInput isCardInput={true} {...getCVCProps({ onChange: onCvcChange })} />
      </Styled.CardInputRow>
      <Styled.CardInputRow isCardInput={true}>
        <Styled.CardImage isCardInput={true} {...getCardImageProps({ images })} />
        <RectangleButton
          isValid={isValid}
          onClick={onSubmit}
          mood={isValid ? 'positive' : 'disabled'}
          text='Add card'
          height={25}
          width={80}
          fontSize={12}
        />
      </Styled.CardInputRow>
    </>
  );
};
